<template>
  <core-view />
</template>

<script>
export default {
  components: {
    CoreView: () => import('@/components/core/View'),
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    source: String,
  },
  data: () => ({
    drawer: null,
  }),
  head: {
    bodyAttrs: {
      class: 'hold-transition login-page-sitrendi',
    },
  },
}
</script>

<style>
.login-page-sitrendi {
  background: url('/banner/4.webp') no-repeat center center fixed;
  background-size: 100% auto;
  min-height: 100vh;
}
@media only screen and (max-width: 767px) {
  .login-page-sitrendi {
    background: url('/banner/4.webp') no-repeat center center fixed;
    background-size: 100%;
    background-position: center;
  }
}
</style>
